import React from "react"
import Table from "react-bootstrap/Table"

import styles from "./Table.module.scss"

const ModifiedTable = ({ caption, head, body, type }) => {
  const headList = head?.map((item, i) => {
    return (
      <th scope="col" key={i}>
        {item}
      </th>
    )
  })

  const bodyList = body?.map((item, i) => {
    const row = item.row.map((item, i) => {
      return <td key={i} dangerouslySetInnerHTML={{ __html: item }}></td>
    })

    return <tr key={i}>{row}</tr>
  })

  const table = (
    <Table responsive>
      {caption && <caption>{caption}</caption>}
      {headList && (
        <thead>
          <tr>{headList}</tr>
        </thead>
      )}
      {bodyList && <tbody>{bodyList}</tbody>}
    </Table>
  )

  if (type === "break-out") {
    return (
      <section className={`${styles.table} section-break-out`}>
        <div className="container">{table}</div>
      </section>
    )
  } else {
    return <section className={styles.table}>{table}</section>
  }
}

ModifiedTable.defaultProps = {}

ModifiedTable.defaultProps = {
  type: "default",
}

export default ModifiedTable
